import React, { useState } from "react";

const OwnershipPriceDetails = ({ setFormData, formData }) => {
    const ownershipOptions = ["Freehold", "Leasehold", "Co-operative society", "Power of Attorney"];


    const handleInputChange = (field, value) => {
        setFormData((prevData) => ({
            ...prevData,
            pricingAndOthers: {
                ...prevData.pricingAndOthers,
                OwnershipPriceDetails: {
                    ...prevData.pricingAndOthers.OwnershipPriceDetails,
                    [field]: value,
                },
            },
        }));
    };


    const handleAdditionalDetailsChange = (field, value) => {
        setFormData((prevData) => ({
            ...prevData,
            pricingAndOthers: {
                ...prevData.pricingAndOthers,
                OwnershipPriceDetails: {
                    ...prevData.pricingAndOthers.OwnershipPriceDetails,
                    additionalDetails: {
                        ...prevData.pricingAndOthers.OwnershipPriceDetails.additionalDetails,
                        [field]: value,
                    },
                },
            },
        }));
    };


    const { OwnershipPriceDetails } = formData?.pricingAndOthers || {};
    const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);

    return (
        <div className="bg-white">
            <h2 className="text-lg font-semibold mb-4">Ownership</h2>
            <div className="flex items-center flex-wrap flex-shrink-0 space-y-2 space-x-4 mb-6">
                {ownershipOptions.map((option) => (
                    <button
                        type="button"
                        key={option}
                        className={`px-2 py-1 text-sm rounded focus:outline-none ${OwnershipPriceDetails?.ownershipType === option
                                ? "bg-blue-500 text-white"
                                : "bg-gray-200 text-gray-700"
                            }`}
                        onClick={() => handleInputChange("ownershipType", option)}
                    >
                        {option}
                    </button>
                ))}
            </div>

            <h2 className="text-lg font-semibold mb-4">Price Details</h2>
            <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="flex space-x-3 items-center">
                    <div className="w-full">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Expected Price
                        </label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring ring-blue-400"
                            placeholder="₹ 1,20,000"
                            value={OwnershipPriceDetails?.expectedPrice}
                            onChange={(e) => handleInputChange("expectedPrice", e.target.value)}
                        />
                    </div>
                    <div className="w-32">
                        <label className="block text-sm font-medium text-gray-700 mb-1 whitespace-nowrap">
                            Price per sq.ft.
                        </label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring ring-blue-400"
                            placeholder="171"
                            value={OwnershipPriceDetails?.pricePerSqFt || ""}
                            onChange={(e) => handleInputChange("pricePerSqFt", e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <p className="text-sm text-gray-500 mt-4">
                ₹ {OwnershipPriceDetails?.expectedPrice || "0"} ({OwnershipPriceDetails?.pricePerSqFt || "0"} per sq.ft.)
            </p>


            <div className="mt-6 space-y-2">
                {[
                    { id: "allInclusive", label: "All inclusive price" },
                    { id: "taxExcluded", label: "Tax and Govt. charges excluded" },
                    { id: "priceNegotiable", label: "Price Negotiable" },
                ].map(({ id, label }) => (
                    <div key={id} className="flex items-center">
                        <input
                            type="checkbox"
                            id={id}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            checked={OwnershipPriceDetails?.[id] || false}
                            onChange={(e) => handleInputChange(id, e.target.checked)}
                        />
                        <label htmlFor={id} className="ml-2 text-sm text-gray-700">
                            {label}
                        </label>
                    </div>
                ))}
            </div>

            {/* Toggle Additional Pricing Details */}
            {showAdditionalDetails && (
                <div className="mt-6 border-t pt-4">
                    <h3 className="text-sm font-semibold text-gray-700 mb-2">
                        Additional Pricing Details <span className="text-gray-500">(Optional)</span>
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div className="flex items-center space-x-4">
                            <input
                                type="text"
                                placeholder="Maintenance"
                                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring ring-blue-400"
                                value={OwnershipPriceDetails?.additionalDetails?.maintenance || ""}
                                onChange={(e) =>
                                    handleAdditionalDetailsChange("maintenance", e.target.value)
                                }
                            />
                            <select
                                className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring ring-blue-400"
                                value={OwnershipPriceDetails?.additionalDetails?.maintenanceType || "Monthly"}
                                onChange={(e) =>
                                    handleAdditionalDetailsChange("maintenanceType", e.target.value)
                                }
                            >
                                <option>Monthly</option>
                                <option>Quarterly</option>
                                <option>Yearly</option>
                            </select>
                        </div>
                        {/* not show on if select independ house villa */}
                     {  <input
                            type="text"
                            placeholder="Booking Amount"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring ring-blue-400"
                            value={OwnershipPriceDetails?.additionalDetails?.bookingAmount || ""}

                            onChange={(e) =>
                                handleAdditionalDetailsChange("bookingAmount", e.target.value)
                            }
                        />}

                        <input
                            type="text"
                            placeholder="Expected rental"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring ring-blue-400"
                             value={OwnershipPriceDetails?.additionalDetails?.expectedRental || ""}
                            onChange={(e) =>
                                handleAdditionalDetailsChange("expectedRental", e.target.value)
                            }
                        />

                        <input
                            type="text"
                            placeholder="Annual dues payable"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring ring-blue-400"
                            value={OwnershipPriceDetails?.additionalDetails?.annualDues || ""}
                            onChange={(e) =>
                                handleAdditionalDetailsChange("annualDues", e.target.value)
                            }
                        />
                        <input
                            type="text"
                            placeholder="Membership charge"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring ring-blue-400"
                            value={OwnershipPriceDetails?.additionalDetails?.membershipCharge || ""}
                            onChange={(e) =>
                                handleAdditionalDetailsChange("membershipCharge", e.target.value)
                            }
                        />
                    </div>
                </div>
            )}

            <button
            type="button"
                onClick={() => setShowAdditionalDetails(!showAdditionalDetails)}
                className="mt-4 text-blue-600 text-sm font-medium hover:underline"
            >
                {showAdditionalDetails ? "˄ Hide pricing details" : "+ Add more pricing details"}
            </button>

            <div className="mb-4 mt-6">
                <label className="block text-sm font-medium mb-2">
                    What makes your property unique
                </label>
                <textarea
                    className="w-full border rounded-md px-3 py-2"
                    rows={5}
                    placeholder="Share some details about your property like spacious rooms, well-maintained facilities..."
                    value={OwnershipPriceDetails?.propertyDescription || ""}
                    onChange={(e) => handleInputChange("propertyDescription", e.target.value)}
                ></textarea>
                <p className="text-sm text-gray-500 mt-1">
                    Minimum 30 characters required <span className="float-right">{OwnershipPriceDetails?.propertyDescription?.length || 0}/5000</span>
                </p>
            </div>
        </div>
    );
};

export default OwnershipPriceDetails;